export default __webpack_public_path__ + "static/media/data.a38ec4a8.png";